const cityStateData = [
    { city: 'Port Blair', state: 'Andaman and Nicobar Islands' },
    { city: 'Adilabad', state: 'Andhra Pradesh' },
    { city: 'Adoni', state: 'Andhra Pradesh' },
    { city: 'Akkarampalle', state: 'Andhra Pradesh' },
    { city: 'Amadalavalasa', state: 'Andhra Pradesh' },
    { city: 'Amalapuram', state: 'Andhra Pradesh' },
    { city: 'Anakapalle', state: 'Andhra Pradesh' },
    { city: 'Anantapur', state: 'Andhra Pradesh' },
    { city: 'Bapatla', state: 'Andhra Pradesh' },
    { city: 'Bheemunipatnam', state: 'Andhra Pradesh' },
    { city: 'Bhimavaram', state: 'Andhra Pradesh' },
    { city: 'Bobbili', state: 'Andhra Pradesh' },
    { city: 'Chilakaluripet', state: 'Andhra Pradesh' },
    { city: 'Chirala', state: 'Andhra Pradesh' },
    { city: 'Chittoor', state: 'Andhra Pradesh' },
    { city: 'Cuddapah', state: 'Andhra Pradesh' },
    { city: 'Dharmavaram', state: 'Andhra Pradesh' },
    { city: 'Eluru', state: 'Andhra Pradesh' },
    { city: 'Gudivada', state: 'Andhra Pradesh' },
    { city: 'Gudur', state: 'Andhra Pradesh' },
    { city: 'Guntakal', state: 'Andhra Pradesh' },
    { city: 'Guntur', state: 'Andhra Pradesh' },
    { city: 'Hindupur', state: 'Andhra Pradesh' },
    { city: 'Ichchapuram', state: 'Andhra Pradesh' },
    { city: 'Jaggaiahpet', state: 'Andhra Pradesh' },
    { city: 'Jammalamadugu', state: 'Andhra Pradesh' },
    { city: 'Kadapa', state: 'Andhra Pradesh' },
    { city: 'Kadiri', state: 'Andhra Pradesh' },
    { city: 'Kakinada', state: 'Andhra Pradesh' },
    { city: 'Kalyandurg', state: 'Andhra Pradesh' },
    { city: 'Kandukur', state: 'Andhra Pradesh' },
    { city: 'Kavali', state: 'Andhra Pradesh' },
    { city: 'Kovvur', state: 'Andhra Pradesh' },
    { city: 'Kurnool', state: 'Andhra Pradesh' },
    { city: 'Macherla', state: 'Andhra Pradesh' },
    { city: 'Machilipatnam', state: 'Andhra Pradesh' },
    { city: 'Madanapalle', state: 'Andhra Pradesh' },
    { city: 'Mandapeta', state: 'Andhra Pradesh' },
    { city: 'Markapur', state: 'Andhra Pradesh' },
    { city: 'Nagari', state: 'Andhra Pradesh' },
    { city: 'Naidupet', state: 'Andhra Pradesh' },
    { city: 'Nandyal', state: 'Andhra Pradesh' },
    { city: 'Narasapur', state: 'Andhra Pradesh' },
    { city: 'Narasaraopet', state: 'Andhra Pradesh' },
    { city: 'Narsipatnam', state: 'Andhra Pradesh' },
    { city: 'Nellore', state: 'Andhra Pradesh' },
    { city: 'Nidadavole', state: 'Andhra Pradesh' },
    { city: 'Nuzvid', state: 'Andhra Pradesh' },
    { city: 'Ongole', state: 'Andhra Pradesh' },
    { city: 'Palacole', state: 'Andhra Pradesh' },
    { city: 'Palasa Kasibugga', state: 'Andhra Pradesh' },
    { city: 'Parvathipuram', state: 'Andhra Pradesh' },
    { city: 'Pedana', state: 'Andhra Pradesh' },
    { city: 'Peddapuram', state: 'Andhra Pradesh' },
    { city: 'Pithapuram', state: 'Andhra Pradesh' },
    { city: 'Ponnur', state: 'Andhra Pradesh' },
    { city: 'Proddatur', state: 'Andhra Pradesh' },
    { city: 'Punganur', state: 'Andhra Pradesh' },
    { city: 'Puttur', state: 'Andhra Pradesh' },
    { city: 'Rajahmundry', state: 'Andhra Pradesh' },
    { city: 'Rajampet', state: 'Andhra Pradesh' },
    { city: 'Rajam', state: 'Andhra Pradesh' },
    { city: 'Ramachandrapuram', state: 'Andhra Pradesh' },
    { city: 'Rayachoti', state: 'Andhra Pradesh' },
    { city: 'Rayadurg', state: 'Andhra Pradesh' },
    { city: 'Renigunta', state: 'Andhra Pradesh' },
    { city: 'Repalle', state: 'Andhra Pradesh' },
    { city: 'Salur', state: 'Andhra Pradesh' },
    { city: 'Samalkot', state: 'Andhra Pradesh' },
    { city: 'Sattenapalle', state: 'Andhra Pradesh' },
    { city: 'Srikakulam', state: 'Andhra Pradesh' },
    { city: 'Srikalahasti', state: 'Andhra Pradesh' },
    { city: 'Tadepalligudem', state: 'Andhra Pradesh' },
    { city: 'Tadpatri', state: 'Andhra Pradesh' },
    { city: 'Tanuku', state: 'Andhra Pradesh' },
    { city: 'Tenali', state: 'Andhra Pradesh' },
    { city: 'Tirupati', state: 'Andhra Pradesh' },
    { city: 'Tuni', state: 'Andhra Pradesh' },
    { city: 'Uravakonda', state: 'Andhra Pradesh' },
    { city: 'Venkatagiri', state: 'Andhra Pradesh' },
    { city: 'Vijayawada', state: 'Andhra Pradesh' },
    { city: 'Vinukonda', state: 'Andhra Pradesh' },
    { city: 'Visakhapatnam', state: 'Andhra Pradesh' },
    { city: 'Vizianagaram', state: 'Andhra Pradesh' },
    { city: 'Yemmiganur', state: 'Andhra Pradesh' },
    { city: 'Yerraguntla', state: 'Andhra Pradesh' },
    { city: 'Along', state: 'Arunachal Pradesh' },
    { city: 'Bomdila', state: 'Arunachal Pradesh' },
    { city: 'Itanagar', state: 'Arunachal Pradesh' },
    { city: 'Naharlagun', state: 'Arunachal Pradesh' },
    { city: 'Pasighat', state: 'Arunachal Pradesh' },
    { city: 'Tawang', state: 'Arunachal Pradesh' },
    { city: 'Abhayapuri', state: 'Assam' },
    { city: 'Amguri', state: 'Assam' },
    { city: 'Barpeta', state: 'Assam' },
    { city: 'Barpeta Road', state: 'Assam' },
    { city: 'Bilasipara', state: 'Assam' },
    { city: 'Bongaigaon', state: 'Assam' },
    { city: 'Dhekiajuli', state: 'Assam' },
    { city: 'Dhubri', state: 'Assam' },
    { city: 'Dibrugarh', state: 'Assam' },
    { city: 'Digboi', state: 'Assam' },
    { city: 'Diphu', state: 'Assam' },
    { city: 'Dispur', state: 'Assam' },
    { city: 'Goalpara', state: 'Assam' },
    { city: 'Golaghat', state: 'Assam' },
    { city: 'Guwahati', state: 'Assam' },
    { city: 'Haflong', state: 'Assam' },
    { city: 'Hailakandi', state: 'Assam' },
    { city: 'Hojai', state: 'Assam' },
    { city: 'Jorhat', state: 'Assam' },
    { city: 'Karimganj', state: 'Assam' },
    { city: 'Kokrajhar', state: 'Assam' },
    { city: 'Lanka', state: 'Assam' },
    { city: 'Lumding', state: 'Assam' },
    { city: 'Mangaldoi', state: 'Assam' },
    { city: 'Mankachar', state: 'Assam' },
    { city: 'Margherita', state: 'Assam' },
    { city: 'Mariani', state: 'Assam' },
    { city: 'Marigaon', state: 'Assam' },
    { city: 'Nagaon', state: 'Assam' },
    { city: 'Nalbari', state: 'Assam' },
    { city: 'North Lakhimpur', state: 'Assam' },
    { city: 'Rangia', state: 'Assam' },
    { city: 'Sibsagar', state: 'Assam' },
    { city: 'Silapathar', state: 'Assam' },
    { city: 'Silchar', state: 'Assam' },
    { city: 'Tezpur', state: 'Assam' },
    { city: 'Tinsukia', state: 'Assam' },
    { city: 'Amarpur', state: 'Bihar' },
    { city: 'Araria', state: 'Bihar' },
    { city: 'Areraj', state: 'Bihar' },
    { city: 'Arrah', state: 'Bihar' },
    { city: 'Asarganj', state: 'Bihar' },
    { city: 'Aurangabad', state: 'Bihar' },
    { city: 'Bagaha', state: 'Bihar' },
    { city: 'Bahadurganj', state: 'Bihar' },
    { city: 'Bairgania', state: 'Bihar' },
    { city: 'Bakhtiarpur', state: 'Bihar' },
    { city: 'Banka', state: 'Bihar' },
    { city: 'Banmankhi Bazar', state: 'Bihar' },
    { city: 'Barahiya', state: 'Bihar' },
    { city: 'Barauli', state: 'Bihar' },
    { city: 'Barbigha', state: 'Bihar' },
    { city: 'Barh', state: 'Bihar' },
    { city: 'Begusarai', state: 'Bihar' },
    { city: 'Behea', state: 'Bihar' },
    { city: 'Bettiah', state: 'Bihar' },
    { city: 'Bhabua', state: 'Bihar' },
    { city: 'Bhagalpur', state: 'Bihar' },
    { city: 'Bihar Sharif', state: 'Bihar' },
    { city: 'Bikramganj', state: 'Bihar' },
    { city: 'Bodh Gaya', state: 'Bihar' },
    { city: 'Buxar', state: 'Bihar' },
    { city: 'Chandan Bara', state: 'Bihar' },
    { city: 'Chanpatia', state: 'Bihar' },
    { city: 'Chhapra', state: 'Bihar' },
    { city: 'Colgong', state: 'Bihar' },
    { city: 'Dalsinghsarai', state: 'Bihar' },
    { city: 'Darbhanga', state: 'Bihar' },
    { city: 'Daudnagar', state: 'Bihar' },
    { city: 'Dehri-on-Sone', state: 'Bihar' },
    { city: 'Dhaka', state: 'Bihar' },
    { city: 'Dighwara', state: 'Bihar' },
    { city: 'Dumraon', state: 'Bihar' },
    { city: 'Fatwah', state: 'Bihar' },
    { city: 'Forbesganj', state: 'Bihar' },
    { city: 'Gaya', state: 'Bihar' },
    { city: 'Gogri Jamalpur', state: 'Bihar' },
    { city: 'Gopalganj', state: 'Bihar' },
    { city: 'Hajipur', state: 'Bihar' },
    { city: 'Hilsa', state: 'Bihar' },
    { city: 'Hisua', state: 'Bihar' },
    { city: 'Islampur', state: 'Bihar' },
    { city: 'Jagdispur', state: 'Bihar' },
    { city: 'Jamalpur', state: 'Bihar' },
    { city: 'Jamui', state: 'Bihar' },
    { city: 'Jehanabad', state: 'Bihar' },
    { city: 'Jhajha', state: 'Bihar' },
    { city: 'Jhanjharpur', state: 'Bihar' },
    { city: 'Jogabani', state: 'Bihar' },
    { city: 'Kanti', state: 'Bihar' },
    { city: 'Katihar', state: 'Bihar' },
    { city: 'Khagaria', state: 'Bihar' },
    { city: 'Kharagpur', state: 'Bihar' },
    { city: 'Kishanganj', state: 'Bihar' },
    { city: 'Lakhisarai', state: 'Bihar' },
    { city: 'Lalganj', state: 'Bihar' },
    { city: 'Madhepura', state: 'Bihar' },
    { city: 'Madhubani', state: 'Bihar' },
    { city: 'Maharajganj', state: 'Bihar' },
    { city: 'Mahnar Bazar', state: 'Bihar' },
    { city: 'Makhdumpur', state: 'Bihar' },
    { city: 'Maner', state: 'Bihar' },
    { city: 'Manihari', state: 'Bihar' },
    { city: 'Marhaura', state: 'Bihar' },
    { city: 'Masaurhi', state: 'Bihar' },
    { city: 'Mirganj', state: 'Bihar' },
    { city: 'Mokameh', state: 'Bihar' },
    { city: 'Motihari', state: 'Bihar' },
    { city: 'Motipur', state: 'Bihar' },
    { city: 'Munger', state: 'Bihar' },
    { city: 'Murliganj', state: 'Bihar' },
    { city: 'Muzaffarpur', state: 'Bihar' },
    { city: 'Narkatiaganj', state: 'Bihar' },
    { city: 'Naugachhia', state: 'Bihar' },
    { city: 'Nawada', state: 'Bihar' },
    { city: 'Nokha', state: 'Bihar' },
    { city: 'Patna', state: 'Bihar' },
    { city: 'Piro', state: 'Bihar' },
    { city: 'Purnia', state: 'Bihar' },
    { city: 'Rafiganj', state: 'Bihar' },
    { city: 'Rajgir', state: 'Bihar' },
    { city: 'Ramnagar', state: 'Bihar' },
    { city: 'Raxaul Bazar', state: 'Bihar' },
    { city: 'Revelganj', state: 'Bihar' },
    { city: 'Rosera', state: 'Bihar' },
    { city: 'Saharsa', state: 'Bihar' },
    { city: 'Samastipur', state: 'Bihar' },
    { city: 'Sasaram', state: 'Bihar' },
    { city: 'Sheikhpura', state: 'Bihar' },
    { city: 'Sheohar', state: 'Bihar' },
    { city: 'Sherghati', state: 'Bihar' },
    { city: 'Silao', state: 'Bihar' },
    { city: 'Sitamarhi', state: 'Bihar' },
    { city: 'Siwan', state: 'Bihar' },
    { city: 'Sonepur', state: 'Bihar' },
    { city: 'Sugauli', state: 'Bihar' },
    { city: 'Sultanganj', state: 'Bihar' },
    { city: 'Supaul', state: 'Bihar' },
    { city: 'Warisaliganj', state: 'Bihar' },
    { city: 'Chandigarh', state: 'Chandigarh' },
    { city: 'Ahiwara', state: 'Chhattisgarh' },
    { city: 'Akaltara', state: 'Chhattisgarh' },
    { city: 'Ambagarh Chowki', state: 'Chhattisgarh' },
    { city: 'Ambikapur', state: 'Chhattisgarh' },
    { city: 'Arang', state: 'Chhattisgarh' },
    { city: 'Bade Bacheli', state: 'Chhattisgarh' },
    { city: 'Balod', state: 'Chhattisgarh' },
    { city: 'Baloda Bazar', state: 'Chhattisgarh' },
    { city: 'Bemetra', state: 'Chhattisgarh' },
    { city: 'Bhatapara', state: 'Chhattisgarh' },
    { city: 'Bhilai', state: 'Chhattisgarh' },
    { city: 'Bilaspur', state: 'Chhattisgarh' },
    { city: 'Birgaon', state: 'Chhattisgarh' },
    { city: 'Champa', state: 'Chhattisgarh' },
    { city: 'Chirmiri', state: 'Chhattisgarh' },
    { city: 'Dalli-Rajhara', state: 'Chhattisgarh' },
    { city: 'Dhamtari', state: 'Chhattisgarh' },
    { city: 'Dipka', state: 'Chhattisgarh' },
    { city: 'Dongargarh', state: 'Chhattisgarh' },
    { city: 'Durg', state: 'Chhattisgarh' },
    { city: 'Gobranawapara', state: 'Chhattisgarh' },
    { city: 'Jagdalpur', state: 'Chhattisgarh' },
    { city: 'Janjgir', state: 'Chhattisgarh' },
    { city: 'Jashpurnagar', state: 'Chhattisgarh' },
    { city: 'Kanker', state: 'Chhattisgarh' },
    { city: 'Kawardha', state: 'Chhattisgarh' },
    { city: 'Kondagaon', state: 'Chhattisgarh' },
    { city: 'Korba', state: 'Chhattisgarh' },
    { city: 'Mahasamund', state: 'Chhattisgarh' },
    { city: 'Mahendragarh', state: 'Chhattisgarh' },
    { city: 'Mungeli', state: 'Chhattisgarh' },
    { city: 'Naila Janjgir', state: 'Chhattisgarh' },
    { city: 'Raigarh', state: 'Chhattisgarh' },
    { city: 'Raipur', state: 'Chhattisgarh' },
    { city: 'Rajnandgaon', state: 'Chhattisgarh' },
    { city: 'Sakti', state: 'Chhattisgarh' },
    { city: 'Tilda Newra', state: 'Chhattisgarh' },
    { city: 'Amli', state: 'Dadra and Nagar Haveli and Daman and Diu' },
    { city: 'Daman', state: 'Dadra and Nagar Haveli and Daman and Diu' },
    { city: 'Diu', state: 'Dadra and Nagar Haveli and Daman and Diu' },
    { city: 'Silvassa', state: 'Dadra and Nagar Haveli and Daman and Diu' },
    { city: 'Asola', state: 'Delhi' },
    { city: 'Delhi', state: 'Delhi' },
    { city: 'New Delhi', state: 'Delhi' },
    { city: 'Aldona', state: 'Goa' },
    { city: 'Curchorem Cacora', state: 'Goa' },
    { city: 'Madgaon', state: 'Goa' },
    { city: 'Mapusa', state: 'Goa' },
    { city: 'Margao', state: 'Goa' },
    { city: 'Marmagao', state: 'Goa' },
    { city: 'Panaji', state: 'Goa' },
    { city: 'Ponda', state: 'Goa' },
    { city: 'Vasco da Gama', state: 'Goa' },
    { city: 'Adalaj', state: 'Gujarat' },
    { city: 'Ahmedabad', state: 'Gujarat' },
    { city: 'Amreli', state: 'Gujarat' },
    { city: 'Anand', state: 'Gujarat' },
    { city: 'Anjar', state: 'Gujarat' },
    { city: 'Ankleshwar', state: 'Gujarat' },
    { city: 'Bardoli', state: 'Gujarat' },
    { city: 'Bharuch', state: 'Gujarat' },
    { city: 'Bhavnagar', state: 'Gujarat' },
    { city: 'Bhuj', state: 'Gujarat' },
    { city: 'Billimora', state: 'Gujarat' },
    { city: 'Borsad', state: 'Gujarat' },
    { city: 'Botad', state: 'Gujarat' },
    { city: 'Cambay', state: 'Gujarat' },
    { city: 'Dahod', state: 'Gujarat' },
    { city: 'Deesa', state: 'Gujarat' },
    { city: 'Dharampur', state: 'Gujarat' },
    { city: 'Dholka', state: 'Gujarat' },
    { city: 'Dhoraji', state: 'Gujarat' },
    { city: 'Dwarka', state: 'Gujarat' },
    { city: 'Gandhidham', state: 'Gujarat' },
    { city: 'Gandhinagar', state: 'Gujarat' },
    { city: 'Godhra', state: 'Gujarat' },
    { city: 'Gondal', state: 'Gujarat' },
    { city: 'Halol', state: 'Gujarat' },
    { city: 'Himatnagar', state: 'Gujarat' },
    { city: 'Idar', state: 'Gujarat' },
    { city: 'Jamnagar', state: 'Gujarat' },
    { city: 'Jetpur', state: 'Gujarat' },
    { city: 'Junagadh', state: 'Gujarat' },
    { city: 'Kadi', state: 'Gujarat' },
    { city: 'Kalol', state: 'Gujarat' },
    { city: 'Kapadvanj', state: 'Gujarat' },
    { city: 'Karjan', state: 'Gujarat' },
    { city: 'Keshod', state: 'Gujarat' },
    { city: 'Khambhalia', state: 'Gujarat' },
    { city: 'Khambhat', state: 'Gujarat' },
    { city: 'Kheda', state: 'Gujarat' },
    { city: 'Khedbrahma', state: 'Gujarat' },
    { city: 'Kheralu', state: 'Gujarat' },
    { city: 'Kodinar', state: 'Gujarat' },
    { city: 'Lathi', state: 'Gujarat' },
    { city: 'Limbdi', state: 'Gujarat' },
    { city: 'Lunawada', state: 'Gujarat' },
    { city: 'Mahesana', state: 'Gujarat' },
    { city: 'Mahuva', state: 'Gujarat' },
    { city: 'Manavadar', state: 'Gujarat' },
    { city: 'Mandvi', state: 'Gujarat' },
    { city: 'Mangrol', state: 'Gujarat' },
    { city: 'Mansa', state: 'Gujarat' },
    { city: 'Mehmedabad', state: 'Gujarat' },
    { city: 'Modasa', state: 'Gujarat' },
    { city: 'Morvi', state: 'Gujarat' },
    { city: 'Nadiad', state: 'Gujarat' },
    { city: 'Navsari', state: 'Gujarat' },
    { city: 'Padra', state: 'Gujarat' },
    { city: 'Palanpur', state: 'Gujarat' },
    { city: 'Palitana', state: 'Gujarat' },
    { city: 'Pardi', state: 'Gujarat' },
    { city: 'Patan', state: 'Gujarat' },
    { city: 'Petlad', state: 'Gujarat' },
    { city: 'Porbandar', state: 'Gujarat' },
    { city: 'Radhanpur', state: 'Gujarat' },
    { city: 'Rajkot', state: 'Gujarat' },
    { city: 'Rajpipla', state: 'Gujarat' },
    { city: 'Rajula', state: 'Gujarat' },
    { city: 'Ranavav', state: 'Gujarat' },
    { city: 'Rapar', state: 'Gujarat' },
    { city: 'Salaya', state: 'Gujarat' },
    { city: 'Sanand', state: 'Gujarat' },
    { city: 'Savarkundla', state: 'Gujarat' },
    { city: 'Sidhpur', state: 'Gujarat' },
    { city: 'Sihor', state: 'Gujarat' },
    { city: 'Songadh', state: 'Gujarat' },
    { city: 'Surat', state: 'Gujarat' },
    { city: 'Surendranagar', state: 'Gujarat' },
    { city: 'Talaja', state: 'Gujarat' },
    { city: 'Thangadh', state: 'Gujarat' },
    { city: 'Tharad', state: 'Gujarat' },
    { city: 'Umbergaon', state: 'Gujarat' },
    { city: 'Umreth', state: 'Gujarat' },
    { city: 'Una', state: 'Gujarat' },
    { city: 'Unjha', state: 'Gujarat' },
    { city: 'Upleta', state: 'Gujarat' },
    { city: 'Vadnagar', state: 'Gujarat' },
    { city: 'Vadodara', state: 'Gujarat' },
    { city: 'Valsad', state: 'Gujarat' },
    { city: 'Vapi', state: 'Gujarat' },
    { city: 'Veraval', state: 'Gujarat' },
    { city: 'Vijapur', state: 'Gujarat' },
    { city: 'Viramgam', state: 'Gujarat' },
    { city: 'Visnagar', state: 'Gujarat' },
    { city: 'Vyara', state: 'Gujarat' },
    { city: 'Wadhwan', state: 'Gujarat' },
    { city: 'Wankaner', state: 'Gujarat' },
    { city: 'Ambala', state: 'Haryana' },
    { city: 'Asankhurd', state: 'Haryana' },
    { city: 'Assandh', state: 'Haryana' },
    { city: 'Ateli', state: 'Haryana' },
    { city: 'Babiyal', state: 'Haryana' },
    { city: 'Bahadurgarh', state: 'Haryana' },
    { city: 'Barwala', state: 'Haryana' },
    { city: 'Bhiwani', state: 'Haryana' },
    { city: 'Charkhi Dadri', state: 'Haryana' },
    { city: 'Cheeka', state: 'Haryana' },
    { city: 'Ellenabad', state: 'Haryana' },
    { city: 'Faridabad', state: 'Haryana' },
    { city: 'Fatehabad', state: 'Haryana' },
    { city: 'Ganaur', state: 'Haryana' },
    { city: 'Gharaunda', state: 'Haryana' },
    { city: 'Gohana', state: 'Haryana' },
    { city: 'Gurgaon', state: 'Haryana' },
    { city: 'Hansi', state: 'Haryana' },
    { city: 'Hisar', state: 'Haryana' },
    { city: 'Hodal', state: 'Haryana' },
    { city: 'Jhajjar', state: 'Haryana' },
    { city: 'Jind', state: 'Haryana' },
    { city: 'Kaithal', state: 'Haryana' },
    { city: 'Kalan Wali', state: 'Haryana' },
    { city: 'Kalka', state: 'Haryana' },
    { city: 'Karnal', state: 'Haryana' },
    { city: 'Ladwa', state: 'Haryana' },
    { city: 'Mandi Dabwali', state: 'Haryana' },
    { city: 'Narnaul', state: 'Haryana' },
    { city: 'Narwana', state: 'Haryana' },
    { city: 'Palwal', state: 'Haryana' },
    { city: 'Panchkula', state: 'Haryana' },
    { city: 'Panipat', state: 'Haryana' },
    { city: 'Pehowa', state: 'Haryana' },
    { city: 'Pinjore', state: 'Haryana' },
    { city: 'Rania', state: 'Haryana' },
    { city: 'Ratia', state: 'Haryana' },
    { city: 'Rewari', state: 'Haryana' },
    { city: 'Rohtak', state: 'Haryana' },
    { city: 'Safidon', state: 'Haryana' },
    { city: 'Samalkha', state: 'Haryana' },
    { city: 'Shahbad', state: 'Haryana' },
    { city: 'Sirsa', state: 'Haryana' },
    { city: 'Sohna', state: 'Haryana' },
    { city: 'Sonipat', state: 'Haryana' },
    { city: 'Taraori', state: 'Haryana' },
    { city: 'Thanesar', state: 'Haryana' },
    { city: 'Tohana', state: 'Haryana' },
    { city: 'Yamunanagar', state: 'Haryana' },
    { city: 'Arki', state: 'Himachal Pradesh' },
    { city: 'Baddi', state: 'Himachal Pradesh' },
    { city: 'Bilaspur', state: 'Himachal Pradesh' },
    { city: 'Chamba', state: 'Himachal Pradesh' },
    { city: 'Dalhousie', state: 'Himachal Pradesh' },
    { city: 'Dharamsala', state: 'Himachal Pradesh' },
    { city: 'Hamirpur', state: 'Himachal Pradesh' },
    { city: 'Kangra', state: 'Himachal Pradesh' },
    { city: 'Kullu', state: 'Himachal Pradesh' },
    { city: 'Mandi', state: 'Himachal Pradesh' },
    { city: 'Nahan', state: 'Himachal Pradesh' },
    { city: 'Palampur', state: 'Himachal Pradesh' },
    { city: 'Shimla', state: 'Himachal Pradesh' },
    { city: 'Solan', state: 'Himachal Pradesh' },
    { city: 'Sundarnagar', state: 'Himachal Pradesh' },
    { city: 'Achabbal', state: 'Jammu and Kashmir' },
    { city: 'Akhnoor', state: 'Jammu and Kashmir' },
    { city: 'Anantnag', state: 'Jammu and Kashmir' },
    { city: 'Arnia', state: 'Jammu and Kashmir' },
    { city: 'Awantipora', state: 'Jammu and Kashmir' },
    { city: 'Bandipore', state: 'Jammu and Kashmir' },
    { city: 'Baramula', state: 'Jammu and Kashmir' },
    { city: 'Jammu', state: 'Jammu and Kashmir' },
    { city: 'Kathua', state: 'Jammu and Kashmir' },
    { city: 'Punch', state: 'Jammu and Kashmir' },
    { city: 'Rajauri', state: 'Jammu and Kashmir' },
    { city: 'Sopore', state: 'Jammu and Kashmir' },
    { city: 'Srinagar', state: 'Jammu and Kashmir' },
    { city: 'Udhampur', state: 'Jammu and Kashmir' },
    { city: 'Amlabad', state: 'Jharkhand' },
    { city: 'Bokaro Steel City', state: 'Jharkhand' },
    { city: 'Chaibasa', state: 'Jharkhand' },
    { city: 'Chakradharpur', state: 'Jharkhand' },
    { city: 'Chandrapura', state: 'Jharkhand' },
    { city: 'Chatra', state: 'Jharkhand' },
    { city: 'Chirkunda', state: 'Jharkhand' },
    { city: 'Daltonganj', state: 'Jharkhand' },
    { city: 'Deoghar', state: 'Jharkhand' },
    { city: 'Dhanbad', state: 'Jharkhand' },
    { city: 'Dumka', state: 'Jharkhand' },
    { city: 'Garhwa', state: 'Jharkhand' },
    { city: 'Ghatshila', state: 'Jharkhand' },
    { city: 'Giridih', state: 'Jharkhand' },
    { city: 'Godda', state: 'Jharkhand' },
    { city: 'Gomoh', state: 'Jharkhand' },
    { city: 'Gumia', state: 'Jharkhand' },
    { city: 'Gumla', state: 'Jharkhand' },
    { city: 'Hazaribag', state: 'Jharkhand' },
    { city: 'Hussainabad', state: 'Jharkhand' },
    { city: 'Jamshedpur', state: 'Jharkhand' },
    { city: 'Jamtara', state: 'Jharkhand' },
    { city: 'Jhumri Tilaiya', state: 'Jharkhand' },
    { city: 'Khunti', state: 'Jharkhand' },
    { city: 'Lohardaga', state: 'Jharkhand' },
    { city: 'Madhupur', state: 'Jharkhand' },
    { city: 'Mihijam', state: 'Jharkhand' },
    { city: 'Musabani', state: 'Jharkhand' },
    { city: 'Pakaur', state: 'Jharkhand' },
    { city: 'Patratu', state: 'Jharkhand' },
    { city: 'Phusro', state: 'Jharkhand' },
    { city: 'Ramgarh', state: 'Jharkhand' },
    { city: 'Ranchi', state: 'Jharkhand' },
    { city: 'Sahibganj', state: 'Jharkhand' },
    { city: 'Saunda', state: 'Jharkhand' },
    { city: 'Simdega', state: 'Jharkhand' },
    { city: 'Tenu Dam-cum-Kathhara', state: 'Jharkhand' },
    { city: 'Arasikere', state: 'Karnataka' },
    { city: 'Bangalore', state: 'Karnataka' },
    { city: 'Belgaum', state: 'Karnataka' },
    { city: 'Bellary', state: 'Karnataka' },
    { city: 'Bhadravati', state: 'Karnataka' },
    { city: 'Bidar', state: 'Karnataka' },
    { city: 'Bijapur', state: 'Karnataka' },
    { city: 'Chamrajnagar', state: 'Karnataka' },
    { city: 'Channapatna', state: 'Karnataka' },
    { city: 'Chikballapur', state: 'Karnataka' },
    { city: 'Chikmagalur', state: 'Karnataka' },
    { city: 'Chintamani', state: 'Karnataka' },
    { city: 'Chitradurga', state: 'Karnataka' },
    { city: 'Dandeli', state: 'Karnataka' },
    { city: 'Davanagere', state: 'Karnataka' },
    { city: 'Dharwad', state: 'Karnataka' },
    { city: 'Gadag-Betageri', state: 'Karnataka' },
    { city: 'Gangawati', state: 'Karnataka' },
    { city: 'Gokak', state: 'Karnataka' },
    { city: 'Gulbarga', state: 'Karnataka' },
    { city: 'Gundlupet', state: 'Karnataka' },
    { city: 'Harihar', state: 'Karnataka' },
    { city: 'Hassan', state: 'Karnataka' },
    { city: 'Haveri', state: 'Karnataka' },
    { city: 'Hospet', state: 'Karnataka' },
    { city: 'Hubli', state: 'Karnataka' },
    { city: 'Ilkal', state: 'Karnataka' },
    { city: 'Jamkhandi', state: 'Karnataka' },
    { city: 'Karkala', state: 'Karnataka' },
    { city: 'Karwar', state: 'Karnataka' },
    { city: 'Kolar', state: 'Karnataka' },
    { city: 'Kollegal', state: 'Karnataka' },
    { city: 'Koppal', state: 'Karnataka' },
    { city: 'Lakshmeshwar', state: 'Karnataka' },
    { city: 'Lingsugur', state: 'Karnataka' },
    { city: 'Maddur', state: 'Karnataka' },
    { city: 'Madhugiri', state: 'Karnataka' },
    { city: 'Madikeri', state: 'Karnataka' },
    { city: 'Magadi', state: 'Karnataka' },
    { city: 'Mahalingpur', state: 'Karnataka' },
    { city: 'Malavalli', state: 'Karnataka' },
    { city: 'Malur', state: 'Karnataka' },
    { city: 'Mandya', state: 'Karnataka' },
    { city: 'Mangalore', state: 'Karnataka' },
    { city: 'Manvi', state: 'Karnataka' },
    { city: 'Mudalgi', state: 'Karnataka' },
    { city: 'Mudbidri', state: 'Karnataka' },
    { city: 'Muddebihal', state: 'Karnataka' },
    { city: 'Mudhol', state: 'Karnataka' },
    { city: 'Mulbagal', state: 'Karnataka' },
    { city: 'Mundargi', state: 'Karnataka' },
    { city: 'Mysore', state: 'Karnataka' },
    { city: 'Nanjangud', state: 'Karnataka' },
    { city: 'Nipani', state: 'Karnataka' },
    { city: 'Pavagada', state: 'Karnataka' },
    { city: 'Puttur', state: 'Karnataka' },
    { city: 'Rabkavi Banhatti', state: 'Karnataka' },
    { city: 'Raichur', state: 'Karnataka' },
    { city: 'Ramanagaram', state: 'Karnataka' },
    { city: 'Ramdurg', state: 'Karnataka' },
    { city: 'Ranibennur', state: 'Karnataka' },
    { city: 'Robertson Pet', state: 'Karnataka' },
    { city: 'Ron', state: 'Karnataka' },
    { city: 'Sadalgi', state: 'Karnataka' },
    { city: 'Sagar', state: 'Karnataka' },
    { city: 'Sakleshpur', state: 'Karnataka' },
    { city: 'Sandur', state: 'Karnataka' },
    { city: 'Sankeshwar', state: 'Karnataka' },
    { city: 'Saundatti-Yellamma', state: 'Karnataka' },
    { city: 'Savanur', state: 'Karnataka' },
    { city: 'Sedam', state: 'Karnataka' },
    { city: 'Shahabad', state: 'Karnataka' },
    { city: 'Shahpur', state: 'Karnataka' },
    { city: 'Shiggaon', state: 'Karnataka' },
    { city: 'Shikapur', state: 'Karnataka' },
    { city: 'Shimoga', state: 'Karnataka' },
    { city: 'Shorapur', state: 'Karnataka' },
    { city: 'Shrirangapattana', state: 'Karnataka' },
    { city: 'Sidlaghatta', state: 'Karnataka' },
    { city: 'Sindgi', state: 'Karnataka' },
    { city: 'Sindhnur', state: 'Karnataka' },
    { city: 'Sira', state: 'Karnataka' },
    { city: 'Sirsi', state: 'Karnataka' },
    { city: 'Siruguppa', state: 'Karnataka' },
    { city: 'Srinivaspur', state: 'Karnataka' },
    { city: 'Talikota', state: 'Karnataka' },
    { city: 'Tarikere', state: 'Karnataka' },
    { city: 'Tekkalakota', state: 'Karnataka' },
    { city: 'Terdal', state: 'Karnataka' },
    { city: 'Tiptur', state: 'Karnataka' },
    { city: 'Tumkur', state: 'Karnataka' },
    { city: 'Udupi', state: 'Karnataka' },
    { city: 'Vijayapura', state: 'Karnataka' },
    { city: 'Wadi', state: 'Karnataka' },
    { city: 'Yadgir', state: 'Karnataka' },
    { city: 'Adoor', state: 'Kerala' },
    { city: 'Alappuzha', state: 'Kerala' },
    { city: 'Attingal', state: 'Kerala' },
    { city: 'Chalakudy', state: 'Kerala' },
    { city: 'Changanassery', state: 'Kerala' },
    { city: 'Cherthala', state: 'Kerala' },
    { city: 'Chittur-Thathamangalam', state: 'Kerala' },
    { city: 'Guruvayoor', state: 'Kerala' },
    { city: 'Irinjalakuda', state: 'Kerala' },
    { city: 'Kanhangad', state: 'Kerala' },
    { city: 'Kannur', state: 'Kerala' },
    { city: 'Kasaragod', state: 'Kerala' },
    { city: 'Kayamkulam', state: 'Kerala' },
    { city: 'Kochi', state: 'Kerala' },
    { city: 'Kodungallur', state: 'Kerala' },
    { city: 'Kollam', state: 'Kerala' },
    { city: 'Koothuparamba', state: 'Kerala' },
    { city: 'Kothamangalam', state: 'Kerala' },
    { city: 'Kottayam', state: 'Kerala' },
    { city: 'Kozhikode', state: 'Kerala' },
    { city: 'Kunnamkulam', state: 'Kerala' },
    { city: 'Malappuram', state: 'Kerala' },
    { city: 'Mattannur', state: 'Kerala' },
    { city: 'Mavelikkara', state: 'Kerala' },
    { city: 'Muvattupuzha', state: 'Kerala' },
    { city: 'Nedumangad', state: 'Kerala' },
    { city: 'Neyyattinkara', state: 'Kerala' },
    { city: 'Ottappalam', state: 'Kerala' },
    { city: 'Palai', state: 'Kerala' },
    { city: 'Palakkad', state: 'Kerala' },
    { city: 'Paravoor', state: 'Kerala' },
    { city: 'Pathanamthitta', state: 'Kerala' },
    { city: 'Payyannur', state: 'Kerala' },
    { city: 'Perinthalmanna', state: 'Kerala' },
    { city: 'Perumbavoor', state: 'Kerala' },
    { city: 'Ponnani', state: 'Kerala' },
    { city: 'Punalur', state: 'Kerala' },
    { city: 'Quilandy', state: 'Kerala' },
    { city: 'Shoranur', state: 'Kerala' },
    { city: 'Taliparamba', state: 'Kerala' },
    { city: 'Thalassery', state: 'Kerala' },
    { city: 'Thiruvalla', state: 'Kerala' },
    { city: 'Thiruvananthapuram', state: 'Kerala' },
    { city: 'Thodupuzha', state: 'Kerala' },
    { city: 'Thrissur', state: 'Kerala' },
    { city: 'Tirur', state: 'Kerala' },
    { city: 'Vadakara', state: 'Kerala' },
    { city: 'Vaikom', state: 'Kerala' },
    { city: 'Varkala', state: 'Kerala' },
    { city: 'Kargil', state: 'Ladakh' },
    { city: 'Leh', state: 'Ladakh' },
    { city: 'Kavaratti', state: 'Lakshadweep' },
    { city: 'Ashok Nagar', state: 'Madhya Pradesh' },
    { city: 'Balaghat', state: 'Madhya Pradesh' },
    { city: 'Betul', state: 'Madhya Pradesh' },
    { city: 'Bhind', state: 'Madhya Pradesh' },
    { city: 'Bhopal', state: 'Madhya Pradesh' },
    { city: 'Burhanpur', state: 'Madhya Pradesh' },
    { city: 'Chhatarpur', state: 'Madhya Pradesh' },
    { city: 'Chhindwara', state: 'Madhya Pradesh' },
    { city: 'Dabra', state: 'Madhya Pradesh' },
    { city: 'Damoh', state: 'Madhya Pradesh' },
    { city: 'Datia', state: 'Madhya Pradesh' },
    { city: 'Dewas', state: 'Madhya Pradesh' },
    { city: 'Dhar', state: 'Madhya Pradesh' },
    { city: 'Guna', state: 'Madhya Pradesh' },
    { city: 'Gwalior', state: 'Madhya Pradesh' },
    { city: 'Harda', state: 'Madhya Pradesh' },
    { city: 'Hoshangabad', state: 'Madhya Pradesh' },
    { city: 'Indore', state: 'Madhya Pradesh' },
    { city: 'Itarsi', state: 'Madhya Pradesh' },
    { city: 'Jabalpur', state: 'Madhya Pradesh' },
    { city: 'Jaora', state: 'Madhya Pradesh' },
    { city: 'Khandwa', state: 'Madhya Pradesh' },
    { city: 'Khargone', state: 'Madhya Pradesh' },
    { city: 'Mandsaur', state: 'Madhya Pradesh' },
    { city: 'Mhow', state: 'Madhya Pradesh' },
    { city: 'Morena', state: 'Madhya Pradesh' },
    { city: 'Murwara (Katni)', state: 'Madhya Pradesh' },
    { city: 'Nagda', state: 'Madhya Pradesh' },
    { city: 'Narsinghgarh', state: 'Madhya Pradesh' },
    { city: 'Neemuch', state: 'Madhya Pradesh' },
    { city: 'Panna', state: 'Madhya Pradesh' },
    { city: 'Parasia', state: 'Madhya Pradesh' },
    { city: 'Pithampur', state: 'Madhya Pradesh' },
    { city: 'Ratlam', state: 'Madhya Pradesh' },
    { city: 'Rewa', state: 'Madhya Pradesh' },
    { city: 'Sagar', state: 'Madhya Pradesh' },
    { city: 'Sarni', state: 'Madhya Pradesh' },
    { city: 'Satna', state: 'Madhya Pradesh' },
    { city: 'Sehore', state: 'Madhya Pradesh' },
    { city: 'Sendhwa', state: 'Madhya Pradesh' },
    { city: 'Seoni', state: 'Madhya Pradesh' },
    { city: 'Shahdol', state: 'Madhya Pradesh' },
    { city: 'Shajapur', state: 'Madhya Pradesh' },
    { city: 'Sheopur', state: 'Madhya Pradesh' },
    { city: 'Shivpuri', state: 'Madhya Pradesh' },
    { city: 'Sidhi', state: 'Madhya Pradesh' },
    { city: 'Singrauli', state: 'Madhya Pradesh' },
    { city: 'Tikamgarh', state: 'Madhya Pradesh' },
    { city: 'Ujjain', state: 'Madhya Pradesh' },
    { city: 'Umaria', state: 'Madhya Pradesh' },
    { city: 'Vidisha', state: 'Madhya Pradesh' },
    { city: 'Ahmednagar', state: 'Maharashtra' },
    { city: 'Akola', state: 'Maharashtra' },
    { city: 'Akot', state: 'Maharashtra' },
    { city: 'Amalner', state: 'Maharashtra' },
    { city: 'Ambejogai', state: 'Maharashtra' },
    { city: 'Amravati', state: 'Maharashtra' },
    { city: 'Anjangaon', state: 'Maharashtra' },
    { city: 'Arvi', state: 'Maharashtra' },
    { city: 'Aurangabad', state: 'Maharashtra' },
    { city: 'Badlapur', state: 'Maharashtra' },
    { city: 'Ballarpur', state: 'Maharashtra' },
    { city: 'Baramati', state: 'Maharashtra' },
    { city: 'Barshi', state: 'Maharashtra' },
    { city: 'Basmath', state: 'Maharashtra' },
    { city: 'Beed', state: 'Maharashtra' },
    { city: 'Bhandara', state: 'Maharashtra' },
    { city: 'Bhiwandi', state: 'Maharashtra' },
    { city: 'Bhusawal', state: 'Maharashtra' },
    { city: 'Buldhana', state: 'Maharashtra' },
    { city: 'Chalisgaon', state: 'Maharashtra' },
    { city: 'Chandrapur', state: 'Maharashtra' },
    { city: 'Chikhli', state: 'Maharashtra' },
    { city: 'Chiplun', state: 'Maharashtra' },
    { city: 'Chopda', state: 'Maharashtra' },
    { city: 'Dahanu', state: 'Maharashtra' },
    { city: 'Deolali', state: 'Maharashtra' },
    { city: 'Dhule', state: 'Maharashtra' },
    { city: 'Dombivli', state: 'Maharashtra' },
    { city: 'Gadchiroli', state: 'Maharashtra' },
    { city: 'Gondia', state: 'Maharashtra' },
    { city: 'Hinganghat', state: 'Maharashtra' },
    { city: 'Hingoli', state: 'Maharashtra' },
    { city: 'Ichalkaranji', state: 'Maharashtra' },
    { city: 'Jalgaon', state: 'Maharashtra' },
    { city: 'Jalna', state: 'Maharashtra' },
    { city: 'Jamner', state: 'Maharashtra' },
    { city: 'Kalyan', state: 'Maharashtra' },
    { city: 'Kamthi', state: 'Maharashtra' },
    { city: 'Karad', state: 'Maharashtra' },
    { city: 'Karanja', state: 'Maharashtra' },
    { city: 'Khamgaon', state: 'Maharashtra' },
    { city: 'Khopoli', state: 'Maharashtra' },
    { city: 'Kolhapur', state: 'Maharashtra' },
    { city: 'Kopargaon', state: 'Maharashtra' },
    { city: 'Latur', state: 'Maharashtra' },
    { city: 'Lonavla', state: 'Maharashtra' },
    { city: 'Malegaon', state: 'Maharashtra' },
    { city: 'Malkapur', state: 'Maharashtra' },
    { city: 'Manmad', state: 'Maharashtra' },
    { city: 'Miraj', state: 'Maharashtra' },
    { city: 'Mumbai', state: 'Maharashtra' },
    { city: 'Nagpur', state: 'Maharashtra' },
    { city: 'Nalasopara', state: 'Maharashtra' },
    { city: 'Nanded-Waghala', state: 'Maharashtra' },
    { city: 'Nandurbar', state: 'Maharashtra' },
    { city: 'Nashik', state: 'Maharashtra' },
    { city: 'Navi Mumbai', state: 'Maharashtra' },
    { city: 'Osmanabad', state: 'Maharashtra' },
    { city: 'Palghar', state: 'Maharashtra' },
    { city: 'Pandharpur', state: 'Maharashtra' },
    { city: 'Panvel', state: 'Maharashtra' },
    { city: 'Parbhani', state: 'Maharashtra' },
    { city: 'Parli', state: 'Maharashtra' },
    { city: 'Phaltan', state: 'Maharashtra' },
    { city: 'Pimpri-Chinchwad', state: 'Maharashtra' },
    { city: 'Pune', state: 'Maharashtra' },
    { city: 'Pusad', state: 'Maharashtra' },
    { city: 'Ratnagiri', state: 'Maharashtra' },
    { city: 'Sangamner', state: 'Maharashtra' },
    { city: 'Sangli', state: 'Maharashtra' },
    { city: 'Satara', state: 'Maharashtra' },
    { city: 'Sawantwadi', state: 'Maharashtra' },
    { city: 'Shahade', state: 'Maharashtra' },
    { city: 'Shegaon', state: 'Maharashtra' },
    { city: 'Shirdi', state: 'Maharashtra' },
    { city: 'Shirpur-Warwade', state: 'Maharashtra' },
    { city: 'Shrirampur', state: 'Maharashtra' },
    { city: 'Sillod', state: 'Maharashtra' },
    { city: 'Solapur', state: 'Maharashtra' },
    { city: 'Talegaon Dabhade', state: 'Maharashtra' },
    { city: 'Thane', state: 'Maharashtra' },
    { city: 'Udgir', state: 'Maharashtra' },
    { city: 'Ulhasnagar', state: 'Maharashtra' },
    { city: 'Uran Islampur', state: 'Maharashtra' },
    { city: 'Vasai-Virar', state: 'Maharashtra' },
    { city: 'Wani', state: 'Maharashtra' },
    { city: 'Wardha', state: 'Maharashtra' },
    { city: 'Warora', state: 'Maharashtra' },
    { city: 'Washim', state: 'Maharashtra' },
    { city: 'Yavatmal', state: 'Maharashtra' },
    { city: 'Imphal', state: 'Manipur' },
    { city: 'Kakching', state: 'Manipur' },
    { city: 'Lilong', state: 'Manipur' },
    { city: 'Mayang Imphal', state: 'Manipur' },
    { city: 'Thoubal', state: 'Manipur' },
    { city: 'Jowai', state: 'Meghalaya' },
    { city: 'Nongstoin', state: 'Meghalaya' },
    { city: 'Shillong', state: 'Meghalaya' },
    { city: 'Tura', state: 'Meghalaya' },
    { city: 'Aizawl', state: 'Mizoram' },
    { city: 'Champhai', state: 'Mizoram' },
    { city: 'Lunglei', state: 'Mizoram' },
    { city: 'Saiha', state: 'Mizoram' },
    { city: 'Dimapur', state: 'Nagaland' },
    { city: 'Kohima', state: 'Nagaland' },
    { city: 'Mokokchung', state: 'Nagaland' },
    { city: 'Tuensang', state: 'Nagaland' },
    { city: 'Wokha', state: 'Nagaland' },
    { city: 'Zunheboto', state: 'Nagaland' },
    { city: 'Anandapur', state: 'Odisha' },
    { city: 'Angul', state: 'Odisha' },
    { city: 'Asika', state: 'Odisha' },
    { city: 'Balangir', state: 'Odisha' },
    { city: 'Balasore', state: 'Odisha' },
    { city: 'Bargarh', state: 'Odisha' },
    { city: 'Baripada', state: 'Odisha' },
    { city: 'Basudebpur', state: 'Odisha' },
    { city: 'Belpahar', state: 'Odisha' },
    { city: 'Bhadrak', state: 'Odisha' },
    { city: 'Bhawanipatna', state: 'Odisha' },
    { city: 'Bhuban', state: 'Odisha' },
    { city: 'Bhubaneswar', state: 'Odisha' },
    { city: 'Biramitrapur', state: 'Odisha' },
    { city: 'Brahmapur', state: 'Odisha' },
    { city: 'Brajrajnagar', state: 'Odisha' },
    { city: 'Byasanagar', state: 'Odisha' },
    { city: 'Cuttack', state: 'Odisha' },
    { city: 'Debagarh (Deogarh)', state: 'Odisha' },
    { city: 'Dhenkanal', state: 'Odisha' },
    { city: 'Gunupur', state: 'Odisha' },
    { city: 'Hinjilicut', state: 'Odisha' },
    { city: 'Jagatsinghapur', state: 'Odisha' },
    { city: 'Jajpur', state: 'Odisha' },
    { city: 'Jaleswar', state: 'Odisha' },
    { city: 'Jatani', state: 'Odisha' },
    { city: 'Jeypore', state: 'Odisha' },
    { city: 'Jharsuguda', state: 'Odisha' },
    { city: 'Joda', state: 'Odisha' },
    { city: 'Kantabanji', state: 'Odisha' },
    { city: 'Karanjia', state: 'Odisha' },
    { city: 'Kendrapara', state: 'Odisha' },
    { city: 'Kendujhar (Keonjhar)', state: 'Odisha' },
    { city: 'Khordha', state: 'Odisha' },
    { city: 'Koraput', state: 'Odisha' },
    { city: 'Malkangiri', state: 'Odisha' },
    { city: 'Nabarangapur', state: 'Odisha' },
    { city: 'Paradip', state: 'Odisha' },
    { city: 'Parlakhemundi', state: 'Odisha' },
    { city: 'Pattamundai', state: 'Odisha' },
    { city: 'Phulabani', state: 'Odisha' },
    { city: 'Puri', state: 'Odisha' },
    { city: 'Rairangpur', state: 'Odisha' },
    { city: 'Rajagangapur', state: 'Odisha' },
    { city: 'Rourkela', state: 'Odisha' },
    { city: 'Rayagada', state: 'Odisha' },
    { city: 'Sambalpur', state: 'Odisha' },
    { city: 'Soro', state: 'Odisha' },
    { city: 'Sunabeda', state: 'Odisha' },
    { city: 'Sundargarh', state: 'Odisha' },
    { city: 'Talcher', state: 'Odisha' },
    { city: 'Titlagarh', state: 'Odisha' },
    { city: 'Umarkote', state: 'Odisha' },
    { city: 'Karaikal', state: 'Puducherry' },
    { city: 'Mahe', state: 'Puducherry' },
    { city: 'Puducherry', state: 'Puducherry' },
    { city: 'Yanam', state: 'Puducherry' },
    { city: 'Ahmedgarh', state: 'Punjab' },
    { city: 'Amritsar', state: 'Punjab' },
    { city: 'Barnala', state: 'Punjab' },
    { city: 'Batala', state: 'Punjab' },
    { city: 'Bathinda', state: 'Punjab' },
    { city: 'Budhlada', state: 'Punjab' },
    { city: 'Dasua', state: 'Punjab' },
    { city: 'Dhuri', state: 'Punjab' },
    { city: 'Dinanagar', state: 'Punjab' },
    { city: 'Faridkot', state: 'Punjab' },
    { city: 'Fazilka', state: 'Punjab' },
    { city: 'Firozpur', state: 'Punjab' },
    { city: 'Firozpur Cantt.', state: 'Punjab' },
    { city: 'Giddarbaha', state: 'Punjab' },
    { city: 'Gobindgarh', state: 'Punjab' },
    { city: 'Gurdaspur', state: 'Punjab' },
    { city: 'Hoshiarpur', state: 'Punjab' },
    { city: 'Jagraon', state: 'Punjab' },
    { city: 'Jaitu', state: 'Punjab' },
    { city: 'Jalalabad', state: 'Punjab' },
    { city: 'Jalandhar', state: 'Punjab' },
    { city: 'Jandiala', state: 'Punjab' },
    { city: 'Kapurthala', state: 'Punjab' },
    { city: 'Kartarpur', state: 'Punjab' },
    { city: 'Khanna', state: 'Punjab' },
    { city: 'Kharar', state: 'Punjab' },
    { city: 'Kot Kapura', state: 'Punjab' },
    { city: 'Kurali', state: 'Punjab' },
    { city: 'Longowal', state: 'Punjab' },
    { city: 'Ludhiana', state: 'Punjab' },
    { city: 'Malerkotla', state: 'Punjab' },
    { city: 'Malout', state: 'Punjab' },
    { city: 'Mansa', state: 'Punjab' },
    { city: 'Maur', state: 'Punjab' },
    { city: 'Moga', state: 'Punjab' },
    { city: 'Mohali', state: 'Punjab' },
    { city: 'Morinda', state: 'Punjab' },
    { city: 'Mukerian', state: 'Punjab' },
    { city: 'Muktsar', state: 'Punjab' },
    { city: 'Nabha', state: 'Punjab' },
    { city: 'Nakodar', state: 'Punjab' },
    { city: 'Nangal', state: 'Punjab' },
    { city: 'Nawanshahr', state: 'Punjab' },
    { city: 'Pathankot', state: 'Punjab' },
    { city: 'Patiala', state: 'Punjab' },
    { city: 'Patran', state: 'Punjab' },
    { city: 'Patti', state: 'Punjab' },
    { city: 'Phagwara', state: 'Punjab' },
    { city: 'Phillaur', state: 'Punjab' },
    { city: 'Qadian', state: 'Punjab' },
    { city: 'Raikot', state: 'Punjab' },
    { city: 'Rajpura', state: 'Punjab' },
    { city: 'Rampura Phul', state: 'Punjab' },
    { city: 'Rupnagar', state: 'Punjab' },
    { city: 'Samana', state: 'Punjab' },
    { city: 'Sangrur', state: 'Punjab' },
    { city: 'Sirhind Fatehgarh Sahib', state: 'Punjab' },
    { city: 'Sujanpur', state: 'Punjab' },
    { city: 'Sunam', state: 'Punjab' },
    { city: 'Talwara', state: 'Punjab' },
    { city: 'Tarn Taran', state: 'Punjab' },
    { city: 'Urmar Tanda', state: 'Punjab' },
    { city: 'Zira', state: 'Punjab' },
    { city: 'Zirakpur', state: 'Punjab' },
    { city: 'Ajmer', state: 'Rajasthan' },
    { city: 'Alwar', state: 'Rajasthan' },
    { city: 'Bali', state: 'Rajasthan' },
    { city: 'Bandikui', state: 'Rajasthan' },
    { city: 'Banswara', state: 'Rajasthan' },
    { city: 'Baran', state: 'Rajasthan' },
    { city: 'Barmer', state: 'Rajasthan' },
    { city: 'Beawar', state: 'Rajasthan' },
    { city: 'Bharatpur', state: 'Rajasthan' },
    { city: 'Bhilwara', state: 'Rajasthan' },
    { city: 'Bhiwadi', state: 'Rajasthan' },
    { city: 'Bikaner', state: 'Rajasthan' },
    { city: 'Bundi', state: 'Rajasthan' },
    { city: 'Chittorgarh', state: 'Rajasthan' },
    { city: 'Churu', state: 'Rajasthan' },
    { city: 'Dausa', state: 'Rajasthan' },
    { city: 'Dholpur', state: 'Rajasthan' },
    { city: 'Fatehpur', state: 'Rajasthan' },
    { city: 'Ganganagar', state: 'Rajasthan' },
    { city: 'Gangapur City', state: 'Rajasthan' },
    { city: 'Hanumangarh', state: 'Rajasthan' },
    { city: 'Hindaun', state: 'Rajasthan' },
    { city: 'Jaipur', state: 'Rajasthan' },
    { city: 'Jaisalmer', state: 'Rajasthan' },
    { city: 'Jalore', state: 'Rajasthan' },
    { city: 'Jhalawar', state: 'Rajasthan' },
    { city: 'Jhunjhunu', state: 'Rajasthan' },
    { city: 'Jodhpur', state: 'Rajasthan' },
    { city: 'Karauli', state: 'Rajasthan' },
    { city: 'Kishangarh', state: 'Rajasthan' },
    { city: 'Kota', state: 'Rajasthan' },
    { city: 'Kuchaman City', state: 'Rajasthan' },
    { city: 'Lachhmangarh', state: 'Rajasthan' },
    { city: 'Ladnu', state: 'Rajasthan' },
    { city: 'Lakheri', state: 'Rajasthan' },
    { city: 'Lalsot', state: 'Rajasthan' },
    { city: 'Losal', state: 'Rajasthan' },
    { city: 'Makrana', state: 'Rajasthan' },
    { city: 'Malpura', state: 'Rajasthan' },
    { city: 'Mandalgarh', state: 'Rajasthan' },
    { city: 'Mandawa', state: 'Rajasthan' },
    { city: 'Mangrol', state: 'Rajasthan' },
    { city: 'Merta City', state: 'Rajasthan' },
    { city: 'Mount Abu', state: 'Rajasthan' },
    { city: 'Nadbai', state: 'Rajasthan' },
    { city: 'Nagar', state: 'Rajasthan' },
    { city: 'Nagaur', state: 'Rajasthan' },
    { city: 'Nasirabad', state: 'Rajasthan' },
    { city: 'Nathdwara', state: 'Rajasthan' },
    { city: 'Nawalgarh', state: 'Rajasthan' },
    { city: 'Neem-Ka-Thana', state: 'Rajasthan' },
    { city: 'Nimbahera', state: 'Rajasthan' },
    { city: 'Niwai', state: 'Rajasthan' },
    { city: 'Nohar', state: 'Rajasthan' },
    { city: 'Nokha', state: 'Rajasthan' },
    { city: 'Pali', state: 'Rajasthan' },
    { city: 'Phalodi', state: 'Rajasthan' },
    { city: 'Phulera', state: 'Rajasthan' },
    { city: 'Pilani', state: 'Rajasthan' },
    { city: 'Pilibanga', state: 'Rajasthan' },
    { city: 'Pindwara', state: 'Rajasthan' },
    { city: 'Pipar City', state: 'Rajasthan' },
    { city: 'Prantij', state: 'Rajasthan' },
    { city: 'Pratapgarh', state: 'Rajasthan' },
    { city: 'Pushkar', state: 'Rajasthan' },
    { city: 'Raisinghnagar', state: 'Rajasthan' },
    { city: 'Rajakhera', state: 'Rajasthan' },
    { city: 'Rajaldesar', state: 'Rajasthan' },
    { city: 'Rajgarh (Alwar)', state: 'Rajasthan' },
    { city: 'Rajgarh (Churu)', state: 'Rajasthan' },
    { city: 'Rajsamand', state: 'Rajasthan' },
    { city: 'Ramganj Mandi', state: 'Rajasthan' },
    { city: 'Ramngarh', state: 'Rajasthan' },
    { city: 'Ratangarh', state: 'Rajasthan' },
    { city: 'Rawatbhata', state: 'Rajasthan' },
    { city: 'Rawatsar', state: 'Rajasthan' },
    { city: 'Reengus', state: 'Rajasthan' },
    { city: 'Sadri', state: 'Rajasthan' },
    { city: 'Sadulshahar', state: 'Rajasthan' },
    { city: 'Sagwara', state: 'Rajasthan' },
    { city: 'Sambhar', state: 'Rajasthan' },
    { city: 'Sanchore', state: 'Rajasthan' },
    { city: 'Sangaria', state: 'Rajasthan' },
    { city: 'Sardarshahar', state: 'Rajasthan' },
    { city: 'Sawai Madhopur', state: 'Rajasthan' },
    { city: 'Shahpura', state: 'Rajasthan' },
    { city: 'Sheoganj', state: 'Rajasthan' },
    { city: 'Sikar', state: 'Rajasthan' },
    { city: 'Sirohi', state: 'Rajasthan' },
    { city: 'Sojat', state: 'Rajasthan' },
    { city: 'Sri Madhopur', state: 'Rajasthan' },
    { city: 'Sujangarh', state: 'Rajasthan' },
    { city: 'Sumerpur', state: 'Rajasthan' },
    { city: 'Suratgarh', state: 'Rajasthan' },
    { city: 'Taranagar', state: 'Rajasthan' },
    { city: 'Todabhim', state: 'Rajasthan' },
    { city: 'Todaraisingh', state: 'Rajasthan' },
    { city: 'Tonk', state: 'Rajasthan' },
    { city: 'Udaipur', state: 'Rajasthan' },
    { city: 'Udaipurwati', state: 'Rajasthan' },
    { city: 'Vijainagar', state: 'Rajasthan' },
    { city: 'Gangtok', state: 'Sikkim' },
    { city: 'Gyalshing', state: 'Sikkim' },
    { city: 'Mangan', state: 'Sikkim' },
    { city: 'Namchi', state: 'Sikkim' },
    { city: 'Arakkonam', state: 'Tamil Nadu' },
    { city: 'Arcot', state: 'Tamil Nadu' },
    { city: 'Aruppukkottai', state: 'Tamil Nadu' },
    { city: 'Attur', state: 'Tamil Nadu' },
    { city: 'Avadi', state: 'Tamil Nadu' },
    { city: 'Bhavani', state: 'Tamil Nadu' },
    { city: 'Chengalpattu', state: 'Tamil Nadu' },
    { city: 'Chennai', state: 'Tamil Nadu' },
    { city: 'Chidambaram', state: 'Tamil Nadu' },
    { city: 'Coimbatore', state: 'Tamil Nadu' },
    { city: 'Coonoor', state: 'Tamil Nadu' },
    { city: 'Cuddalore', state: 'Tamil Nadu' },
    { city: 'Dharmapuri', state: 'Tamil Nadu' },
    { city: 'Dindigul', state: 'Tamil Nadu' },
    { city: 'Erode', state: 'Tamil Nadu' },
    { city: 'Gudalur', state: 'Tamil Nadu' },
    { city: 'Hosur', state: 'Tamil Nadu' },
    { city: 'Kanchipuram', state: 'Tamil Nadu' },
    { city: 'Karaikudi', state: 'Tamil Nadu' },
    { city: 'Karur', state: 'Tamil Nadu' },
    { city: 'Kollankodu', state: 'Tamil Nadu' },
    { city: 'Kovilpatti', state: 'Tamil Nadu' },
    { city: 'Krishnagiri', state: 'Tamil Nadu' },
    { city: 'Kumbakonam', state: 'Tamil Nadu' },
    { city: 'Lalgudi', state: 'Tamil Nadu' },
    { city: 'Madurai', state: 'Tamil Nadu' },
    { city: 'Mannargudi', state: 'Tamil Nadu' },
    { city: 'Mayiladuthurai', state: 'Tamil Nadu' },
    { city: 'Mettupalayam', state: 'Tamil Nadu' },
    { city: 'Mettur', state: 'Tamil Nadu' },
    { city: 'Nagapattinam', state: 'Tamil Nadu' },
    { city: 'Nagercoil', state: 'Tamil Nadu' },
    { city: 'Namakkal', state: 'Tamil Nadu' },
    { city: 'Neyveli', state: 'Tamil Nadu' },
    { city: 'Oddanchatram', state: 'Tamil Nadu' },
    { city: 'Palani', state: 'Tamil Nadu' },
    { city: 'Palladam', state: 'Tamil Nadu' },
    { city: 'Pallavaram', state: 'Tamil Nadu' },
    { city: 'Panruti', state: 'Tamil Nadu' },
    { city: 'Paramakudi', state: 'Tamil Nadu' },
    { city: 'Pattukkottai', state: 'Tamil Nadu' },
    { city: 'Perambalur', state: 'Tamil Nadu' },
    { city: 'Periyakulam', state: 'Tamil Nadu' },
    { city: 'Pollachi', state: 'Tamil Nadu' },
    { city: 'Pudukkottai', state: 'Tamil Nadu' },
    { city: 'Puliyankudi', state: 'Tamil Nadu' },
    { city: 'Rajapalayam', state: 'Tamil Nadu' },
    { city: 'Ramanathapuram', state: 'Tamil Nadu' },
    { city: 'Rameshwaram', state: 'Tamil Nadu' },
    { city: 'Rasipuram', state: 'Tamil Nadu' },
    { city: 'Salem', state: 'Tamil Nadu' },
    { city: 'Sankarankoil', state: 'Tamil Nadu' },
    { city: 'Sathyamangalam', state: 'Tamil Nadu' },
    { city: 'Sivaganga', state: 'Tamil Nadu' },
    { city: 'Sivakasi', state: 'Tamil Nadu' },
    { city: 'Srivilliputhur', state: 'Tamil Nadu' },
    { city: 'Tambaram', state: 'Tamil Nadu' },
    { city: 'Tenkasi', state: 'Tamil Nadu' },
    { city: 'Thanjavur', state: 'Tamil Nadu' },
    { city: 'Tharamangalam', state: 'Tamil Nadu' },
    { city: 'Theni Allinagaram', state: 'Tamil Nadu' },
    { city: 'Thirumangalam', state: 'Tamil Nadu' },
    { city: 'Thirunindravur', state: 'Tamil Nadu' },
    { city: 'Thiruthuraipoondi', state: 'Tamil Nadu' },
    { city: 'Thiruvallur', state: 'Tamil Nadu' },
    { city: 'Thiruvarur', state: 'Tamil Nadu' },
    { city: 'Thoothukudi', state: 'Tamil Nadu' },
    { city: 'Thuraiyur', state: 'Tamil Nadu' },
    { city: 'Tindivanam', 'state': 'Tamil Nadu' },
    { city: 'Tiruchendur', 'state': 'Tamil Nadu' },
    { city: 'Tiruchengode', 'state': 'Tamil Nadu' },
    { city: 'Tiruchirappalli', 'state': 'Tamil Nadu' },
    { city: 'Tirukalukundram', 'state': 'Tamil Nadu' },
    { city: 'Tirukkoyilur', 'state': 'Tamil Nadu' },
    { city: 'Tirunelveli', 'state': 'Tamil Nadu' },
    { city: 'Tirupathur', 'state': 'Tamil Nadu' },
    { city: 'Tiruppur', 'state': 'Tamil Nadu' },
    { city: 'Tiruttani', 'state': 'Tamil Nadu' },
    { city: 'Tiruvannamalai', 'state': 'Tamil Nadu' },
    { city: 'Udhagamandalam', 'state': 'Tamil Nadu' },
    { city: 'Udumalaipettai', 'state': 'Tamil Nadu' },
    { city: 'Usilampatti', 'state': 'Tamil Nadu' },
    { city: 'Valparai', 'state': 'Tamil Nadu' },
    { city: 'Vaniyambadi', 'state': 'Tamil Nadu' },
    { city: 'Vedaranyam', 'state': 'Tamil Nadu' },
    { city: 'Vellore', 'state': 'Tamil Nadu' },
    { city: 'Viluppuram', 'state': 'Tamil Nadu' },
    { city: 'Virudhachalam', 'state': 'Tamil Nadu' },
    { city: 'Virudhunagar', 'state': 'Tamil Nadu' },
    { city: 'Adilabad', 'state': 'Telangana' },
    { city: 'Bellampalle', 'state': 'Telangana' },
    { city: 'Bhadrachalam', 'state': 'Telangana' },
    { city: 'Bhainsa', 'state': 'Telangana' },
    { city: 'Bhongir', 'state': 'Telangana' },
    { city: 'Bodhan', 'state': 'Telangana' },
    { city: 'Farooqnagar', 'state': 'Telangana' },
    { city: 'Gadwal', 'state': 'Telangana' },
    { city: 'Hyderabad', 'state': 'Telangana' },
    { city: 'Jagtial', 'state': 'Telangana' },
    { city: 'Jangaon', 'state': 'Telangana' },
    { city: 'Kagaznagar', 'state': 'Telangana' },
    { city: 'Kamareddy', 'state': 'Telangana' },
    { city: 'Karimnagar', 'state': 'Telangana' },
    { city: 'Khammam', 'state': 'Telangana' },
    { city: 'Koratla', 'state': 'Telangana' },
    { city: 'Kothagudem', 'state': 'Telangana' },
    { city: 'Kyathampalle', 'state': 'Telangana' },
    { city: 'Mahbubnagar', 'state': 'Telangana' },
    { city: 'Mancherial', 'state': 'Telangana' },
    { city: 'Mandamarri', 'state': 'Telangana' },
    { city: 'Manuguru', 'state': 'Telangana' },
    { city: 'Medak', 'state': 'Telangana' },
    { city: 'Miryalaguda', 'state': 'Telangana' },
    { city: 'Nagarkurnool', 'state': 'Telangana' },
    { city: 'Narayanpet', 'state': 'Telangana' },
    { city: 'Nirmal', 'state': 'Telangana' },
    { city: 'Nizamabad', 'state': 'Telangana' },
    { city: 'Palwancha', 'state': 'Telangana' },
    { city: 'Ramagundam', 'state': 'Telangana' },
    { city: 'Sadasivpet', 'state': 'Telangana' },
    { city: 'Sangareddy', 'state': 'Telangana' },
    { city: 'Siddipet', 'state': 'Telangana' },
    { city: 'Sircilla', 'state': 'Telangana' },
    { city: 'Suryapet', 'state': 'Telangana' },
    { city: 'Tandur', 'state': 'Telangana' },
    { city: 'Vicarabad', 'state': 'Telangana' },
    { city: 'Wanaparthy', 'state': 'Telangana' },
    { city: 'Warangal', 'state': 'Telangana' },
    { city: 'Yellandu', 'state': 'Telangana' },
    { city: 'Zahirabad', 'state': 'Telangana' },
    { city: 'Agartala', 'state': 'Tripura' },
    { city: 'Badharghat', 'state': 'Tripura' },
    { city: 'Dharmanagar', 'state': 'Tripura' },
    { city: 'Indranagar', 'state': 'Tripura' },
    { city: 'Jogendranagar', 'state': 'Tripura' },
    { city: 'Kailasahar', 'state': 'Tripura' },
    { city: 'Khowai', 'state': 'Tripura' },
    { city: 'Pratapgarh', 'state': 'Tripura' },
    { city: 'Udaipur', 'state': 'Tripura' },
    { city: 'Achhnera', 'state': 'Uttar Pradesh' },
    { city: 'Agra', 'state': 'Uttar Pradesh' },
    { city: 'Aligarh', 'state': 'Uttar Pradesh' },
    { city: 'Allahabad', 'state': 'Uttar Pradesh' },
    { city: 'Amroha', 'state': 'Uttar Pradesh' },
    { city: 'Auraiya', 'state': 'Uttar Pradesh' },
    { city: 'Azamgarh', 'state': 'Uttar Pradesh' },
    { city: 'Baghpat', 'state': 'Uttar Pradesh' },
    { city: 'Bahraich', 'state': 'Uttar Pradesh' },
    { city: 'Ballia', 'state': 'Uttar Pradesh' },
    { city: 'Balrampur', 'state': 'Uttar Pradesh' },
    { city: 'Banda', 'state': 'Uttar Pradesh' },
    { city: 'Barabanki', 'state': 'Uttar Pradesh' },
    { city: 'Bareilly', 'state': 'Uttar Pradesh' },
    { city: 'Basti', 'state': 'Uttar Pradesh' },
    { city: 'Behta Hajipur', 'state': 'Uttar Pradesh' },
    { city: 'Bhadohi', 'state': 'Uttar Pradesh' },
    { city: 'Bijnor', 'state': 'Uttar Pradesh' },
    { city: 'Budaun', 'state': 'Uttar Pradesh' },
    { city: 'Bulandshahr', 'state': 'Uttar Pradesh' },
    { city: 'Chandausi', 'state': 'Uttar Pradesh' },
    { city: 'Chandpur', 'state': 'Uttar Pradesh' },
    { city: 'Chitrakoot', 'state': 'Uttar Pradesh' },
    { city: 'Dadri', 'state': 'Uttar Pradesh' },
    { city: 'Deoband', 'state': 'Uttar Pradesh' },
    { city: 'Deoria', 'state': 'Uttar Pradesh' },
    { city: 'Etah', 'state': 'Uttar Pradesh' },
    { city: 'Etawah', 'state': 'Uttar Pradesh' },
    { city: 'Faizabad', 'state': 'Uttar Pradesh' },
    { city: 'Farrukhabad', 'state': 'Uttar Pradesh' },
    { city: 'Fatehpur', 'state': 'Uttar Pradesh' },
    { city: 'Firozabad', 'state': 'Uttar Pradesh' },
    { city: 'Gangaghat', 'state': 'Uttar Pradesh' },
    { city: 'Gangoh', 'state': 'Uttar Pradesh' },
    { city: 'Ghaziabad', 'state': 'Uttar Pradesh' },
    { city: 'Ghazipur', 'state': 'Uttar Pradesh' },
    { city: 'Gonda', 'state': 'Uttar Pradesh' },
    { city: 'Gorakhpur', 'state': 'Uttar Pradesh' },
    { city: 'Greater Noida', 'state': 'Uttar Pradesh' },
    { city: 'Hapur', 'state': 'Uttar Pradesh' },
    { city: 'Hardoi', 'state': 'Uttar Pradesh' },
    { city: 'Hathras', 'state': 'Uttar Pradesh' },
    { city: 'Jalaun', 'state': 'Uttar Pradesh' },
    { city: 'Jaunpur', 'state': 'Uttar Pradesh' },
    { city: 'Jhansi', 'state': 'Uttar Pradesh' },
    { city: 'Kairana', 'state': 'Uttar Pradesh' },
    { city: 'Kannauj', 'state': 'Uttar Pradesh' },
    { city: 'Kanpur', 'state': 'Uttar Pradesh' },
    { city: 'Kasganj', 'state': 'Uttar Pradesh' },
    { city: 'Khatauli', 'state': 'Uttar Pradesh' },
    { city: 'Khurja', 'state': 'Uttar Pradesh' },
    { 'city': 'Kiratpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Konch', 'state': 'Uttar Pradesh' },
    { 'city': 'Lakhimpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Lalitpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Loni', 'state': 'Uttar Pradesh' },
    { 'city': 'Lucknow', 'state': 'Uttar Pradesh' },
    { 'city': 'Mahoba', 'state': 'Uttar Pradesh' },
    { 'city': 'Mainpuri', 'state': 'Uttar Pradesh' },
    { 'city': 'Mathura', 'state': 'Uttar Pradesh' },
    { 'city': 'Mau', 'state': 'Uttar Pradesh' },
    { 'city': 'Meerut', 'state': 'Uttar Pradesh' },
    { 'city': 'Mirzapur', 'state': 'Uttar Pradesh' },
    { 'city': 'Modinagar', 'state': 'Uttar Pradesh' },
    { 'city': 'Moradabad', 'state': 'Uttar Pradesh' },
    { 'city': 'Mubarakpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Mughalsarai', 'state': 'Uttar Pradesh' },
    { 'city': 'Muzaffarnagar', 'state': 'Uttar Pradesh' },
    { 'city': 'Nagina', 'state': 'Uttar Pradesh' },
    { 'city': 'Najibabad', 'state': 'Uttar Pradesh' },
    { 'city': 'Noida', 'state': 'Uttar Pradesh' },
    { 'city': 'Obra', 'state': 'Uttar Pradesh' },
    { 'city': 'Orai', 'state': 'Uttar Pradesh' },
    { 'city': 'Pilibhit', 'state': 'Uttar Pradesh' },
    { 'city': 'Pilkhuwa', 'state': 'Uttar Pradesh' },
    { 'city': 'Rae Bareli', 'state': 'Uttar Pradesh' },
    { 'city': 'Rampur', 'state': 'Uttar Pradesh' },
    { 'city': 'Rath', 'state': 'Uttar Pradesh' },
    { 'city': 'Renukoot', 'state': 'Uttar Pradesh' },
    { 'city': 'Saharanpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Sahaswan', 'state': 'Uttar Pradesh' },
    { 'city': 'Sambhal', 'state': 'Uttar Pradesh' },
    { 'city': 'Sandila', 'state': 'Uttar Pradesh' },
    { 'city': 'Shahjahanpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Shamli', 'state': 'Uttar Pradesh' },
    { 'city': 'Shikohabad', 'state': 'Uttar Pradesh' },
    { 'city': 'Sikandrabad', 'state': 'Uttar Pradesh' },
    { 'city': 'Sitapur', 'state': 'Uttar Pradesh' },
    { 'city': 'Sultanpur', 'state': 'Uttar Pradesh' },
    { 'city': 'Tanda', 'state': 'Uttar Pradesh' },
    { 'city': 'Tilhar', 'state': 'Uttar Pradesh' },
    { 'city': 'Tundla', 'state': 'Uttar Pradesh' },
    { 'city': 'Ujhani', 'state': 'Uttar Pradesh' },
    { 'city': 'Unnao', 'state': 'Uttar Pradesh' },
    { 'city': 'Varanasi', 'state': 'Uttar Pradesh' },
    { 'city': 'Vrindavan', 'state': 'Uttar Pradesh' },
    { 'city': 'Almora', 'state': 'Uttarakhand' },
    { 'city': 'Bazpur', 'state': 'Uttarakhand' },
    { 'city': 'Chamba', 'state': 'Uttarakhand' },
    { 'city': 'Dehradun', 'state': 'Uttarakhand' },
    { 'city': 'Haldwani', 'state': 'Uttarakhand' },
    { 'city': 'Haridwar', 'state': 'Uttarakhand' },
    { 'city': 'Jaspur', 'state': 'Uttarakhand' },
    { 'city': 'Kashipur', 'state': 'Uttarakhand' },
    { 'city': 'Kichha', 'state': 'Uttarakhand' },
    { 'city': 'Kotdwara', 'state': 'Uttarakhand' },
    { 'city': 'Manglaur', 'state': 'Uttarakhand' },
    { 'city': 'Mussoorie', 'state': 'Uttarakhand' },
    { 'city': 'Nainital', 'state': 'Uttarakhand' },
    { 'city': 'Pauri', 'state': 'Uttarakhand' },
    { 'city': 'Pithoragarh', 'state': 'Uttarakhand' },
    { 'city': 'Ramnagar', 'state': 'Uttarakhand' },
    { 'city': 'Rishikesh', 'state': 'Uttarakhand' },
    { 'city': 'Roorkee', 'state': 'Uttarakhand' },
    { 'city': 'Rudrapur', 'state': 'Uttarakhand' },
    { 'city': 'Sitarganj', 'state': 'Uttarakhand' },
    { 'city': 'Tehri', 'state': 'Uttarakhand' },
    { 'city': 'Adra', 'state': 'West Bengal' },
    { 'city': 'Alipurduar', 'state': 'West Bengal' },
    { 'city': 'Arambagh', 'state': 'West Bengal' },
    { 'city': 'Asansol', 'state': 'West Bengal' },
    { 'city': 'Ashoknagar Kalyangarh', 'state': 'West Bengal' },
    { 'city': 'Baharampur', 'state': 'West Bengal' },
    { 'city': 'Bally', 'state': 'West Bengal' },
    { 'city': 'Balurghat', 'state': 'West Bengal' },
    { 'city': 'Bangaon', 'state': 'West Bengal' },
    { 'city': 'Bankura', 'state': 'West Bengal' },
    { 'city': 'Baranagar', 'state': 'West Bengal' },
    { 'city': 'Barasat', 'state': 'West Bengal' },
    { 'city': 'Bardhaman', 'state': 'West Bengal' },
    { 'city': 'Basirhat', 'state': 'West Bengal' },
    { 'city': 'Bhatpara', 'state': 'West Bengal' },
    { 'city': 'Bidhannagar', 'state': 'West Bengal' },
    { 'city': 'Bishnupur', 'state': 'West Bengal' },
    { 'city': 'Bolpur', 'state': 'West Bengal' },
    { 'city': 'Budge Budge', 'state': 'West Bengal' },
    { 'city': 'Chakdaha', 'state': 'West Bengal' },
    { 'city': 'Champdani', 'state': 'West Bengal' },
    { 'city': 'Chandannagar', 'state': 'West Bengal' },
    { 'city': 'Contai', 'state': 'West Bengal' },
    { 'city': 'Cooch Behar', 'state': 'West Bengal' },
    { 'city': 'Darjeeling', 'state': 'West Bengal' },
    { 'city': 'Dhulian', 'state': 'West Bengal' },
    { 'city': 'Diamond Harbour', 'state': 'West Bengal' },
    { 'city': 'Dum Dum', 'state': 'West Bengal' },
    { 'city': 'Durgapur', 'state': 'West Bengal' },
    { 'city': 'Gangarampur', 'state': 'West Bengal' },
    { 'city': 'Habra', 'state': 'West Bengal' },
    { 'city': 'Haldia', 'state': 'West Bengal' },
    { 'city': 'Halisahar', 'state': 'West Bengal' },
    { 'city': 'Howrah', 'state': 'West Bengal' },
    { 'city': 'Hugli-Chinsurah', 'state': 'West Bengal' },
    { 'city': 'Islampur', 'state': 'West Bengal' },
    { 'city': 'Jangipur', 'state': 'West Bengal' },
    { 'city': 'Jhargram', 'state': 'West Bengal' },
    { 'city': 'Kalimpong', 'state': 'West Bengal' },
    { 'city': 'Kalyani', 'state': 'West Bengal' },
    { 'city': 'Kamarhati', 'state': 'West Bengal' },
    { 'city': 'Kanchrapara', 'state': 'West Bengal' },
    { 'city': 'Kharagpur', 'state': 'West Bengal' },
    { 'city': 'Kolkata', 'state': 'West Bengal' },
    { 'city': 'Krishnanagar', 'state': 'West Bengal' },
    { 'city': 'Kulti', 'state': 'West Bengal' },
    { 'city': 'Madhyamgram', 'state': 'West Bengal' },
    { 'city': 'Maheshtala', 'state': 'West Bengal' },
    { 'city': 'Malda', 'state': 'West Bengal' },
    { 'city': 'Medinipur', 'state': 'West Bengal' },
    { 'city': 'Nabadwip', 'state': 'West Bengal' },
    { 'city': 'Naihati', 'state': 'West Bengal' },
    { 'city': 'North Barrackpur', 'state': 'West Bengal' },
    { 'city': 'North Dumdum', 'state': 'West Bengal' },
    { 'city': 'Panihati', 'state': 'West Bengal' },
    { 'city': 'Purulia', 'state': 'West Bengal' },
    { 'city': 'Raiganj', 'state': 'West Bengal' },
    { 'city': 'Rajpur Sonarpur', 'state': 'West Bengal' },
    { 'city': 'Ranaghat', 'state': 'West Bengal' },
    { 'city': 'Raniganj', 'state': 'West Bengal' },
    { 'city': 'Santipur', 'state': 'West Bengal' },
    { 'city': 'Serampore', 'state': 'West Bengal' },
    { 'city': 'Siliguri', 'state': 'West Bengal' },
    { 'city': 'South Dumdum', 'state': 'West Bengal' },
    { 'city': 'Tamluk', 'state': 'West Bengal' },
    { 'city': 'Titagarh', 'state': 'West Bengal' },
    { 'city': 'Uluberia', 'state': 'West Bengal' },
    { 'city': 'Uttarpara Kotrung', 'state': 'West Bengal' }
];

export default cityStateData;